import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AuthDataProvider } from '../../providers/auth-data/auth-data';
import { StorageProvider } from '../../providers/storage/storage';
// import { FcmProvider } from '../../providers/fcm/fcm'

import { HomePage } from '../home/home';

/**
 * Generated class for the RegisterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {

  public registerForm: FormGroup;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public authData: AuthDataProvider,
    private storageProvider: StorageProvider,
    // public fcmProvider: FcmProvider
    ) {

    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    let PASSWORD_REGEXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,}$/i;

    this.registerForm = fb.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      first_name: ['', Validators.compose([Validators.minLength(2), Validators.required])],
      last_name: ['', Validators.compose([Validators.minLength(2), Validators.required])],
      username: ['', Validators.compose([Validators.minLength(2), Validators.required])],
      password: ['', Validators.compose([Validators.minLength(8), Validators.required, Validators.pattern(PASSWORD_REGEXP)])],
      confirmpassword: ['', Validators.compose([Validators.minLength(8), Validators.required])]
    }, { validator: this.matchingPasswords('password', 'confirmpassword') });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegisterPage');
  }

  matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
    console.log("Test Validation");
    return (group: FormGroup): { [key: string]: any } => {
      let password = group.controls[passwordKey];
      let confirmPassword = group.controls[confirmPasswordKey];

      if (password.value !== confirmPassword.value) {
        return {
          mismatchedPasswords: true
        };
      } else {
        return null
      }
    }
  }

  registerUser() {
    console.log("call signopUser");
    if (!this.registerForm.valid) {
      console.log(this.registerForm.value);
      this.presentAlert("invalid form");
    } else {

      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: 'Registrando..'
      });
      loadingPopup.present();

      this.storageProvider.get('deviceId').then(resdevice => {

        // let idd = '3406e78a4a80bff1';
        console.log("esto es iddevice", resdevice);
        if (resdevice != null) {
          this.authData.registerUser(this.registerForm.value, resdevice)
            .then(() => {
              // this.fcmProvider.saveToken(resdevice).then(result => {
              //   this.fcmProvider.registerGlobalToken();
              //   loadingPopup.dismiss();
              //   this.navCtrl.setRoot(HomePage);
              // })
              loadingPopup.dismiss();
              this.navCtrl.setRoot(HomePage);
            }, (error) => {
              var errorMessage: string = error.message;
              loadingPopup.dismiss();
              this.presentAlert(errorMessage);
            });
        } else {
          loadingPopup.dismiss();
        }
      })
    }
  }

  presentAlert(title) {
    let alert = this.alertCtrl.create({
      title: title,
      buttons: ['OK']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts